
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"36","height":"36"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","d":"M19.25 14.583h-13c-1.197 0-2.167.97-2.167 2.167v1.083h17.334V16.75c0-1.197-.97-2.167-2.167-2.167zm3.25 3.25V29.75A3.25 3.25 0 0119.25 33h-13A3.25 3.25 0 013 29.75v-13a3.25 3.25 0 013.25-3.25h13a3.25 3.25 0 013.25 3.25v1.083zM4.083 18.917V29.75c0 1.197.97 2.167 2.167 2.167h13c1.197 0 2.167-.97 2.167-2.167V18.917H4.083zm3.25 2.708c0-.3.243-.542.542-.542h2.167a.542.542 0 010 1.084H7.875a.542.542 0 01-.542-.542zm4.875-.542a.542.542 0 000 1.084h5.417a.542.542 0 100-1.084h-5.417zm-4.333 3.25a.542.542 0 000 1.084h2.167a.542.542 0 000-1.084H7.875zm4.333 0a.542.542 0 000 1.084h5.417a.542.542 0 100-1.084h-5.417zm-4.333 3.25a.542.542 0 000 1.084h2.167a.542.542 0 000-1.084H7.875zm4.333 0a.542.542 0 000 1.084h5.417a.542.542 0 100-1.084h-5.417z","clip-rule":"evenodd"}}),_c('path',{attrs:{"d":"M24.5 9.333h-13c-1.197 0-2.167.97-2.167 2.167v2.75H8.25V11.5a3.25 3.25 0 013.25-3.25h13a3.25 3.25 0 013.25 3.25v13a3.25 3.25 0 01-3.25 3.25h-2.75v-1.083h2.75c1.197 0 2.167-.97 2.167-2.167v-13c0-1.197-.97-2.167-2.167-2.167z"}}),_c('path',{attrs:{"d":"M29.75 4.083h-13c-1.197 0-2.167.97-2.167 2.167V9H13.5V6.25A3.25 3.25 0 0116.75 3h13A3.25 3.25 0 0133 6.25v13a3.25 3.25 0 01-3.25 3.25H27v-1.083h2.75c1.197 0 2.167-.97 2.167-2.167v-13c0-1.197-.97-2.167-2.167-2.167z"}})])
          )
        }
      }
    